import { Actions } from "../territory/territoryConstants";
import produce from "immer";

const initialState = {
  data: null,
  loading: false,
};

export const reducer = (state = initialState, action) => {
  return produce(state, (draft) => {
    switch (action.type) {
      case Actions.LIST_TERRITORIES:
        draft.loading = true;
        return draft;
      case Actions.LIST_TERRITORIES_SUCCEEDED:
        draft.loading = false;
        draft.data = action.payload;
        return draft;
      default:
        return state;
    }
  });
};
